import { isPlatformBrowser } from '@angular/common';

const animatedElements = new Set<Element>();

export function createScrollObserver(platformId: object): IntersectionObserver | null {
  if (!isPlatformBrowser(platformId)) {
    return null;
  }

  return new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          animatedElements.add(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' },
  );
}

export function animateOnScroll(observer: IntersectionObserver | null): void {
  if (!observer) return;

  const elements = document.querySelectorAll('.animate-on-scroll');
  elements.forEach(el => {
    if (!animatedElements.has(el)) {
      observer.observe(el);
    }
  });
}

/**
 * Clears the internal cache of animated elements to prevent memory leaks
 * when the host component is destroyed. Must be called from ngOnDestroy
 * before disconnecting the scroll observer.
 */
export function cleanupScrollAnimation(): void {
  animatedElements.clear();
}
